import BlogWidget from './BlogWidget'

export default BlogWidget
